export class Panel {
    constructor (public title: string, public detail: string, public img: string)
    {};
}


// WEBPACK FOOTER //
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/models/panel-model.ts